import { useContactSectionContent } from './useContactSectionContent';
import { parseContactFormContent } from '../utils/contactContent';

export const useContactFormContent = () => useContactSectionContent(parseContactFormContent);
